import Alpine from 'alpinejs'
import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

window.Alpine = Alpine;

Alpine.start();

const swiper = new Swiper('.swiper', {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 24,
    direction: 'horizontal',
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 24
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 1,
          spaceBetween: 24
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        // when window width is >= 768px
        1024: {
          slidesPerView: 3,
          spaceBetween: 24
        }
    }
});
